import React from 'react';
import { useLayoutContext } from '../LayoutState';
import { NavBar as MastheadNav } from '@spotify-internal/s4x-masthead';
import { creatorLightTheme } from '@spotify-internal/encore-foundation';

export const MastheadHeader: React.FC<{}> = ({}) => {
  const layoutContext = useLayoutContext();
  const { navBarBackground, navBarTextColor, navBarBleed } = layoutContext;

  // used for override on legacyPage like /blog or /video to
  // force dark background and light text
  const { invertedDark } = creatorLightTheme;
  return (
    <MastheadNav
      colors={{
        background: navBarBackground || invertedDark.background.base,
        text: navBarTextColor || invertedDark.text.base,
        bleed: navBarBleed,
      }}
    />
  );
};
